import React from 'react';
import { PlayCircleIcon, SparklesIcon } from 'lucide-react';
import { HeroTestimonialCard } from './HeroTestimonialCard';
import { ApplyButton } from './ApplyButton';
interface HeroSectionProps {
  onNavigate?: (sectionId: string) => void;
}
export function HeroSection({
  onNavigate
}: HeroSectionProps) {
  const heroTestimonials = [{
    name: 'Sean L.',
    role: 'transformation client',
    quote: "Ali... Brenden... I can't stress enough how working with this team is guaranteed to provide transformations... Working with them is just a fantastic experience and I highly recommend this to anybody who's even considering, if you're looking for something life-changing, if you want to attack diseases that the mainstream says is not really something treatable, give them a shot because they're going to show you that chances are it's something you can reverse or at the very least slow down... It will blow your mind. That's what I can guarantee.",
    highlight: 'Guaranteed transformations for "untreatable" diseases',
    result: 'Complete Health Transformation',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cu1sUoRKLSqu5aKsChDsLN/SeanL.jpg'
  }, {
    name: 'Wilfred A.',
    role: 'Peptide Mastery buyer & transformation client',
    quote: "I 100% would put my name behind Ali & Brenden. I've had other health coaches in the past (most are MD's), and I must say, Brenden & Ali are FAR more in depth, systems-oriented, and rigorous than anything I've ever seen. Also I did grab that peptides course. It has given me the knowledge to turn familys' health conditions around even when the medical system has failed them. I owe this to the lessons I've acquired from Ali & Brenden. In terms of level of positive impact on my life, they are likely in the top 5 most important people I've ever met as they have added many years to my life and to those of my loved ones.",
    highlight: 'Peptide Mastery course transformed entire family',
    result: 'Family Health Transformation',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/s7vj7xGcWZVbS5exCPVhbw/WilfredA.jpg'
  }, {
    name: 'Glen S., MD',
    role: 'Nephrologist (Kidney Doctor)',
    quote: "As a doctor myself, I was skeptical of anything outside standard cardiology protocols. But conventional medicine had nothing left to offer me except a new heart. My cardiologist was speechless when he saw my latest ejection fraction. He kept checking to make sure he was looking at the right patient's chart! The difference is night and day. I went from barely being able to walk to the bathroom to playing nine holes of golf with my grandson last weekend. What you've done isn't just impressive, it's life-changing.",
    highlight: 'Cardiologist speechless at ejection fraction results',
    result: 'Heart Failure → Playing Golf Again',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/i6mTy32s3ktNurFCsqiCyH/dandandan._Photorealistic_candid-style_photograph_of_a_vibran_b86f9b0e-b8d9-48d0-87af-9911dfada31a_12.png'
  }];
  return <section className="max-w-6xl mx-auto px-6 pt-20 pb-16 relative" data-id="element-70">
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 via-fuchsia-500/10 to-cyan-500/10 rounded-3xl blur-3xl" data-id="element-71"></div>
      <div className="text-center mb-16 relative" data-id="element-72">
        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-fuchsia-500 px-6 py-2.5 rounded-full border border-cyan-400/50 mb-8 shadow-lg shadow-fuchsia-500/30" data-id="element-73">
          <SparklesIcon className="w-4 h-4 text-white" data-id="element-74" />
          <span className="text-sm font-bold text-white" data-id="element-75">
            Complete Health, Vitality & Renewal Program
          </span>
          <SparklesIcon className="w-4 h-4 text-white" data-id="element-76" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-77">
          Take control of your health.{' '}
          <span className="bg-gradient-to-r from-cyan-400 via-fuchsia-400 to-cyan-400 bg-clip-text text-transparent" data-id="element-78">
            Wake up excited about the future.
          </span>{' '}
          GET YOUR LIFE BACK ON TRACK.
        </h1>
        <p className="text-xl md:text-2xl text-cyan-100 max-w-4xl mx-auto leading-relaxed font-medium" data-id="element-79">
          Even if <span className="underline" data-id="element-80">nothing</span> else has worked.
          Even if <span className="underline" data-id="element-81">nobody</span> else has given you
          answers. Even if you've been told{' '}
          <span className="underline" data-id="element-82">you'll just have to "live with it."</span>
        </p>
      </div>
      <div className="relative max-w-5xl mx-auto mb-12" data-id="element-83">
        <div className="aspect-video bg-gradient-to-br from-slate-900 via-fuchsia-900 to-cyan-900 rounded-2xl shadow-2xl overflow-hidden border-2 border-fuchsia-500/30" data-id="element-84">
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-fuchsia-500/10" data-id="element-85"></div>
          <div className="w-full h-full flex items-center justify-center relative" data-id="element-86">
            <div className="text-center" data-id="element-87">
              <div className="relative inline-block mb-6" data-id="element-88">
                <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 to-fuchsia-500 rounded-full blur-2xl opacity-50 animate-pulse" data-id="element-89"></div>
                <PlayCircleIcon className="w-24 h-24 text-cyan-400 relative" data-id="element-90" />
              </div>
              <p className="text-white font-bold text-lg mb-2" data-id="element-91">
                Video Sales Letter
              </p>
              <p className="text-fuchsia-400 text-sm font-semibold" data-id="element-92">
                Click to play
              </p>
            </div>
          </div>
        </div>
        <div className="absolute -inset-6 bg-gradient-to-r from-cyan-500/20 via-fuchsia-500/20 to-cyan-500/20 rounded-3xl blur-3xl -z-10" data-id="element-93"></div>
      </div>
      <div className="text-center mb-16" data-id="element-94">
        <ApplyButton text="Start Your Transformation" onNavigate={onNavigate} data-id="element-95" />
      </div>
      <div className="relative mb-16" data-id="element-96">
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-97">
          {heroTestimonials.map((testimonial, index) => <HeroTestimonialCard key={index} {...testimonial} data-id="element-98" />)}
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-slate-900/50 pointer-events-none" data-id="element-99"></div>
    </section>;
}